<template>
  <li class="list-group-item dock-icons" id="screenRecordingLi">
    <a v-if="!isRecording && !isUploading" @click="startRecording()" class="bottom-dock-btn">
      <i class="bottom-dock-btn__icon bx bx-slideshow" title="Start Screen recording"></i>
    </a>
    <a v-else-if="isRecording && !isUploading" @click="stopRecording()" class="bottom-dock-btn">
      <i class="bottom-dock-btn__icon icon-active bx bx-stop-circle" title="Stop Screen recording"></i>
    </a>
    <a v-else-if="!isRecording && isUploading">
      <div class="spinner-border spinner-border-sm mx-3 mt-2" role="status" title="uploading Screen recording"></div>
    </a>
    <SpeechToText :lang="'en-US'" :text.sync="text" :toggle="captioning" @speechend="speechEnd" />
  </li>
</template>

<script>
import SpeechToText from '@/components/SpeechToText.vue';
import swal from 'sweetalert';
import scr from '../plugins/edScreen';

export default {
  data() {
    return {
      isRecording: false,
      dataStream: [],
      isUploading: false,
      captioning: false,
      text: '',
      sentences: null,
    };
  },
  components: {
    SpeechToText,
  },
  computed: {
    startCaptioning() {
      return this.captioning;
    },
  },
  mounted() {
    this.$root.$on('startScreenRecord', this.startRecording);
    this.$root.$on('stopScreenRecord', this.stopRecording);
  },
  beforeDestroy() {
    this.$root.$off('startScreenRecord');
    this.$root.$off('stopScreenRecord');
  },
  methods: {
    async startRecording() {
      // Get a Screen Recorder instance
      this.recorderInstance = await scr();

      // Start recording

      this.recorderInstance.start();

      // Set isRecording to true
      this.isRecording = true;

      // Set captioning to true
      this.captioning = true;
      // Get the stream
      this.recorderInstance.ondataavailable = (e) => {
        this.dataStream.push(e.data);
      };
      this.recorderInstance.onstop = async () => {
        this.isRecording = false;
        this.captioning = false;
        const recordBlob = new Blob(this.dataStream, {
          type: this.dataStream[0].type,
        });
        this.isUploading = true;
        this.$store.dispatch('uploadToAWS', recordBlob).then(() => {
          this.isUploading = false;
          this.text = '';
          swal('Screen Recording added to your Notes', '', 'success');
        });
      };
    },
    async stopRecording() {
      this.recorderInstance.stop();
    },
    speechEnd({ sentences }) {
      this.sentences = sentences;
    },
  },
};
</script>

<style lang="scss" scoped>
.rec-output {
  position: relative;
  #scr {
    width: 70%;
    height: 30%;
  }

  #videoRec {
    width: 200px;
    height: 200px;
    border-radius: 10px;
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  }
}
</style>
